import React from 'react';
import Navbar from '../../Navbar/Navbar';
import BlogPageInfo from '../BlogPageInfo/BlogPageInfo';

const BlogPageManagement = () => {
    return (
        <div>
            <Navbar />
            <BlogPageInfo />
        </div>
    );
};

export default BlogPageManagement;